<template>
    

    <page-padding>
    
      <infinite-list :key="updateKey" :list="news[news_id+feed]">
        <template v-slot:default="obj">
          
         <news-list-item :key="obj.item.id" :item="obj.item"/>
       
        </template>
      </infinite-list>
      
      
      <div v-if="!hasNews">{{$t('language.no_news')}}</div>
    </page-padding>

</template>

<script>

import { mapState } from 'vuex';
import NewsListItem from './NewsListItem';
import PagePadding from '../../components/PagePadding';
import InfiniteList from '../../components/InfiniteList.vue';
import { eventBus } from '../../services/EventBus.js';

export default {
  name: 'list-news',
  props:{
    news_id:{default:"0"},
    feed:{default:"init"},
  },
  data:function(){
    return {
      hasNews:true,
      updateKey:0,
    }
  },
  components:{
    NewsListItem,
    PagePadding,
    InfiniteList,
  },
  methods:{
    emitLoadStop(){
      // emit to all parent who want to hear..
      let vm=this.$parent;
      while(vm){
        vm.$emit('SCROLLPAGE_STOP_LOAD')
        vm=vm.$parent;
      }
    },
    emitLoadStart(){
      // emit to all parent who want to hear..
      let vm=this.$parent;
      while(vm){
        vm.$emit('SCROLLPAGE_START_LOAD')
        vm=vm.$parent;
      }
    },
    emitLoadEnd(){
      // emit to all parent who want to hear..
      let vm=this.$parent;
      while(vm){
        vm.$emit('SCROLLPAGE_END_LOAD')
        vm=vm.$parent;
      }
    },
    load_news(){
     
      this.emitLoadStart()
      
      if(this.news_id===undefined){
        // undefined is if coming back from add news
        // news id is undefined do not try to load or it will load the global new
        // and messing up the loader spinner
        // global news_id --> 0
        // group news_id --> >0
        return;
      }     
      
     

       var payload={
         id:this.news_id, //global news if undefined
         feed:this.feed,
      }
      
       this.$store.dispatch('get_news',payload).then(()=>{
         this.hasNews = this.news[this.news_id+this.feed] ? this.news[this.news_id+this.feed].length : false;
         this.updateKey=new Date().getTime();
         this.emitLoadEnd();
        
       })
    },
    
  },
  computed:{
    ...mapState([
       'news','loaded'
       ]),
  },
  beforeDestroy(){
      this.emitLoadStop();
      eventBus.$off("RELOAD_FROM_PULL",this.load_news)
    },
  mounted(){
    eventBus.$on("RELOAD_FROM_PULL",this.load_news)
   this.load_news();
   
    
  },
  created(){
    
   
  }
  
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>



</style>

